import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 4,
		fill: "#2358F8"
	})
});
export default SvgDot;
